/* __next_internal_client_entry_do_not_use__ InsiderTileBadgeRenderer auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { TileBadge } from "@faire/retailer-visitor-shared/components/InsiderBadge/__internal__/TileBadge";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";
import { IApplicableMembershipBenefits } from "@faire/web-api--source/indigofair/data/IApplicableMembershipBenefits";
import React from "react";
// TODO (RSC Product Tile): Remove "use client" after this component is migrated to RSC
export var InsiderTileBadgeRenderer = function(props) {
    var _props_insiderBenefits_benefits, _props_insiderBenefits;
    var _useInsiderState = useInsiderState(), isCurrentRetailerInsider = _useInsiderState.isInsider, isInsiderActive = _useInsiderState.isInsiderActive;
    var hasInsiderBenefitsForBrand = !!((_props_insiderBenefits = props.insiderBenefits) === null || _props_insiderBenefits === void 0 ? void 0 : (_props_insiderBenefits_benefits = _props_insiderBenefits.benefits) === null || _props_insiderBenefits_benefits === void 0 ? void 0 : _props_insiderBenefits_benefits.length);
    var shouldShowBadging = isCurrentRetailerInsider;
    if (props.insiderLabelText === undefined) {
        return null;
    }
    if (shouldShowBadging && hasInsiderBenefitsForBrand) {
        return /*#__PURE__*/ _jsx(InsiderTileBadgeRendererContent, _object_spread({
            isInsiderActive: isInsiderActive
        }, props));
    }
    return null;
};
var InsiderTileBadgeRendererContent = function(param) {
    var className = param.className, insiderBenefits = param.insiderBenefits, insiderLabelText = param.insiderLabelText, isInsiderActive = param.isInsiderActive;
    var hasFreeDutyAdvertising = useInsiderFeatureEligibility().hasFreeDutyAdvertising;
    var hasFreeDuties = false;
    if (isInsiderActive || hasFreeDutyAdvertising) {
        hasFreeDuties = !!(insiderBenefits === null || insiderBenefits === void 0 ? void 0 : insiderBenefits.benefits.includes(IApplicableMembershipBenefits.ApplicableMembershipBenefitType.INSIDER_FREE_DUTIES));
    }
    var hasFreeShipping = !!(insiderBenefits === null || insiderBenefits === void 0 ? void 0 : insiderBenefits.benefits.includes(IApplicableMembershipBenefits.ApplicableMembershipBenefitType.INSIDER_FREE_SHIPPING));
    return /*#__PURE__*/ _jsx(TileBadge, {
        className: className,
        hasFreeDuties: hasFreeDuties,
        hasFreeShipping: hasFreeShipping,
        insiderBadgeText: insiderLabelText
    });
};
